













































import { Component, Vue } from 'vue-property-decorator';
import { InvoiceDetailsModule } from '@/store/modules/invoiceDetails';
import InvoiceDetails from '@/components/Invoices/InvoiceDetails.vue';
import InvoiceTimesheets from '@/components/Invoices/InvoiceTimesheets.vue';
import InvoiceJobPlacements from '@/components/Invoices/InvoiceJobPlacements.vue';
import InvoiceLines from '@/components/Invoices/InvoiceLines.vue';
import Alert from '@/components/Shared/Alert.vue';
import InvoiceStatus from '@/components/Invoices/Display/InvoiceStatus.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import IconConstants from '@/lib/iconConstants';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import InvoiceStatusSet from '@/components/Invoices/InvoiceStatusSet.vue';

@Component({
	name: 'AgencyInvoice',
  	components: { Alert, InvoiceDetails, InvoiceTimesheets, InvoiceJobPlacements, InvoiceLines, InvoiceStatus, InvoiceStatusSet }
})
export default class extends GiganautVue {

  StatusDisplayLocation = StatusDisplayLocation;

  get currentInvoice() {
    return InvoiceDetailsModule.currentInvoice;
  }

  get loading() {
    return InvoiceDetailsModule.loading;
  }

  async created() {
    await InvoiceDetailsModule.getInvoice(this.$route.params.invoiceid);
  }

  navigateToInvoiceList() {
    this.$router.push({ name: 'AgencyInvoices' });
  }
}
